import { render, staticRenderFns } from "./ManageLabelsPanel.vue?vue&type=template&id=30193648&scoped=true&"
import script from "./ManageLabelsPanel.vue?vue&type=script&lang=js&"
export * from "./ManageLabelsPanel.vue?vue&type=script&lang=js&"
import style0 from "./ManageLabelsPanel.vue?vue&type=style&index=0&id=30193648&prod&lang=scss&scoped=true&"
import style1 from "./ManageLabelsPanel.vue?vue&type=style&index=1&id=30193648&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30193648",
  null
  
)

export default component.exports